/* Wael Scents — cart drawer glue.
   - Opens Dawn cart-drawer from the custom header cart icon.
   - Gouvernorat selector inside the drawer (+ cart page): saves cart attribute
     via /cart/update.js, blocks checkout (#CartDrawer-Checkout / #checkout) until set.
   - Uses event delegation + MutationObserver so it survives Dawn's drawer re-renders.
   - Adds (featured / product) refresh + open the drawer, matching the React behaviour. */
(function () {
  var CHECKOUT_SEL = '#CartDrawer-Checkout, #checkout, [name="checkout"]';

  function drawerEl() { return document.querySelector('cart-drawer'); }

  // ---- Quick-add (delegated, global) — works on homepage featured AND collection cards.
  //      Button markup comes from snippets/wael-quick-add.liquid ([data-wsx-add] + data-variant-id,
  //      variant already resolved to 100ML server-side). Adds via /cart/add.js then opens the drawer. ----
  document.addEventListener('click', function (e) {
    // Le CSS (wael.css) met pointer-events:none sur le svg/path interne du bouton, donc e.target
    // est déjà le <button> dans les navigateurs modernes. Filet de secours si un ancêtre non-Element
    // (ex: nœud texte) remonte quand même jusqu'ici.
    var node = e.target;
    while (node && node.nodeType !== 1) { node = node.parentNode; }
    var btn = node && node.closest ? node.closest('[data-wsx-add]') : null;
    if (!btn) return;
    // CAPTURE phase : on intercepte AVANT que le lien <a> parent ne navigue.
    e.preventDefault(); e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    var original = btn.innerHTML;
    btn.disabled = true;
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      btn.innerHTML = 'Ajouté ✓';
      if (window.wsxDrawer) window.wsxDrawer.refresh(true);
      setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1600);
    }).catch(function () { btn.innerHTML = original; btn.disabled = false; });
  }, true); /* true = CAPTURE phase */

  function currentGov() {
    var w = document.querySelector('[data-wsx-gov]');
    return w ? (w.getAttribute('data-current') || '') : '';
  }

  function applyCheckoutBlock() {
    // If there is no gouvernorat selector on the page at all, don't block.
    if (!document.querySelector('[data-wsx-gov]')) return;
    var gov = currentGov();
    document.querySelectorAll(CHECKOUT_SEL).forEach(function (b) {
      b.disabled = !gov;
      b.style.opacity = gov ? '' : '0.5';
      b.style.cursor = gov ? '' : 'not-allowed';
    });
    var dyn = document.querySelector('.cart__dynamic-checkout-buttons');
    if (dyn) { dyn.style.pointerEvents = gov ? '' : 'none'; dyn.style.opacity = gov ? '' : '0.5'; }
  }

  function updateHeaderCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var el = document.querySelector('.wsx-cart-count');
        var link = document.querySelector('[data-wsx-cart-open]');
        if (c.item_count > 0) {
          if (!el && link) { el = document.createElement('span'); el.className = 'wsx-cart-count'; link.appendChild(el); }
          if (el) el.textContent = c.item_count;
        } else if (el) { el.remove(); }
      }).catch(function () {});
  }

  // ---- Targeted Storefront API channel: push city = gouvernorat into the SAME cart's
  //      buyerIdentity so Shopify prefills the checkout "Ville" field. Reconciles Dawn's
  //      AJAX cart with the Storefront Cart API via the shared cart token
  //      (gid://shopify/Cart/<token>, where /cart.js token already contains ?key=<secret>).
  //      Runs in parallel with the /cart/update.js attribute write and never blocks it. ----
  function pushBuyerCity(city) {
    var cfg = window.wsxStorefront;
    if (!cfg || !cfg.token) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.token) return;
        var cartId = 'gid://shopify/Cart/' + cart.token; // token already includes ?key=<secret>
        // ── TECH DEBT ──────────────────────────────────────────────────────────────────
        // `deliveryAddressPreferences` on CartBuyerIdentityInput is DEPRECATED since API
        // 2025-01 in favour of the `cartDeliveryAddressesAdd` mutation. We PIN API 2025-07
        // (see snippets/wael-storefront-config.liquid) where it still works — same approach
        // the old React site used, proven to fill order `city`. When it eventually breaks,
        // migrate to `cartDeliveryAddressesAdd` (same cart GID, same public token, different
        // mutation shape). Everything else here stays identical.
        // ───────────────────────────────────────────────────────────────────────────────
        var query = 'mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {'
          + ' cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {'
          + ' cart { id } userErrors { field message } } }';
        var variables = {
          cartId: cartId,
          buyerIdentity: { deliveryAddressPreferences: [{ deliveryAddress: { city: city, country: 'TN' } }] }
        };
        return fetch('https://' + cfg.domain + '/api/' + cfg.version + '/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.token },
          body: JSON.stringify({ query: query, variables: variables })
        }).then(function (r) { return r.json(); }).then(function (res) {
          var errs = (res && res.errors)
            || (res && res.data && res.data.cartBuyerIdentityUpdate && res.data.cartBuyerIdentityUpdate.userErrors)
            || [];
          if (errs.length) console.warn('[wsx] cartBuyerIdentityUpdate error:', errs);
        });
      })
      .catch(function (e) { console.warn('[wsx] buyerIdentity push failed (attribute still saved):', e); });
  }

  // ---- Gouvernorat: open/close toggle + outside click (delegated) ----
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-wsx-gov-opt]');
    if (opt) {
      e.preventDefault();
      var val = opt.getAttribute('data-value');
      // Update every gouvernorat widget on the page (cart page + drawer)
      document.querySelectorAll('[data-wsx-gov]').forEach(function (w) {
        w.setAttribute('data-current', val);
        var cur = w.querySelector('[data-wsx-gov-current]'); if (cur) cur.textContent = val;
        w.querySelectorAll('[data-wsx-gov-opt]').forEach(function (o) { o.classList.toggle('sel', o.getAttribute('data-value') === val); });
        w.classList.remove('open');
        var err = w.querySelector('[data-wsx-gov-error]'); if (err) err.classList.remove('show');
      });
      // (a) Dawn AJAX attribute (informative) — unchanged
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { Gouvernorat: val } })
      }).then(applyCheckoutBlock).catch(function () {});
      // (b) Targeted Storefront buyerIdentity (prefills checkout city) — in parallel, independent
      pushBuyerCity(val);
      return;
    }
    var tog = e.target.closest('[data-wsx-gov-toggle]');
    if (tog) {
      var w = tog.closest('[data-wsx-gov]');
      var open = w.classList.toggle('open');
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var sel = w.getAttribute('data-current');
        if (sel) { var el = w.querySelector('[data-wsx-gov-opt][data-value="' + sel.replace(/"/g, '\\"') + '"]'); if (el) el.scrollIntoView({ block: 'center' }); }
      }
      return;
    }
    document.querySelectorAll('[data-wsx-gov].open').forEach(function (w) { if (!w.contains(e.target)) w.classList.remove('open'); });
  });

  // ---- Guard: clicking a blocked checkout surfaces the error ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(CHECKOUT_SEL);
    if (btn && document.querySelector('[data-wsx-gov]') && !currentGov()) {
      e.preventDefault(); e.stopPropagation();
      var err = document.querySelector('[data-wsx-gov] [data-wsx-gov-error]');
      if (err) { err.classList.add('show'); err.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    }
  }, true);

  // ---- Open the drawer from the custom header cart icon ----
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-wsx-cart-open]');
    if (!link) return;
    var d = drawerEl();
    if (d && typeof d.open === 'function') { e.preventDefault(); d.open(link); }
  });

  // ---- Refresh drawer contents (Section Rendering API) + optionally open ----
  function refresh(open) {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshInner = doc.querySelector('#CartDrawer');
        var freshDrawer = doc.querySelector('cart-drawer');
        var liveInner = document.querySelector('#CartDrawer');
        var liveDrawer = drawerEl();
        if (freshInner && liveInner) liveInner.innerHTML = freshInner.innerHTML;
        if (freshDrawer && liveDrawer) liveDrawer.className = freshDrawer.className;
        var ov = document.querySelector('#CartDrawer-Overlay');
        if (ov && liveDrawer) ov.addEventListener('click', liveDrawer.close.bind(liveDrawer));
        applyCheckoutBlock();
        updateHeaderCount();
        if (open && liveDrawer && typeof liveDrawer.open === 'function') liveDrawer.open();
      }).catch(function () {});
  }

  window.wsxDrawer = { refresh: refresh, open: function () { var d = drawerEl(); if (d) d.open(); } };

  // ---- Observe Dawn's own drawer re-renders (qty change / remove) ----
  function observe() {
    var inner = document.querySelector('#CartDrawer');
    if (!inner) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { applyCheckoutBlock(); updateHeaderCount(); }, 60);
    }).observe(inner, { childList: true, subtree: true });
  }

  function init() { applyCheckoutBlock(); observe(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
